<template>
  <v-container fluid>
    <div v-if="loading">
      <div class="mb-3">
        <v-skeleton-loader type="list-item-two-line"></v-skeleton-loader>
      </div>
      <v-row>
        <v-col cols="12" sm="6" md="6" lg="4" xl="4" v-for="index in 30" :key="index">
          <v-card>
            <v-skeleton-loader type="list-item-three-line"></v-skeleton-loader>
          </v-card>
        </v-col>
      </v-row>
    </div>
    <div v-else>
      <div class="text-h1 mb-4">
        <v-row v-if="relatorios_gerenciais.length > 0">
          <v-col cols="12">
            <div class="text-h1 mb-0">
              Relatórios gerenciais
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="4" xl="4" v-for="(item, index) in relatorios_gerenciais" :key="index">
            <div class="item_lista" :class="item.link ? 'cursor-pointer' : ''" @click="gotoUrl(item.link)" v-ripple="item.link ? { class: `primary--text` } : false">
              <div class="text-h3">
                <v-icon class="mb-1">{{item.icone}}</v-icon>
                {{item.nome}}
              </div>
              <div class="text text-gray mt-2">
                {{item.lead}}
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="relatorios_financeiros.length > 0">
          <v-col cols="12">
            <div class="text-h1 mb-0">
              Relatórios financeiros
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="4" xl="4" v-for="(item, index) in relatorios_financeiros" :key="index">
            <div class="item_lista" :class="item.link ? 'cursor-pointer' : ''" @click="gotoUrl(item.link)" v-ripple="item.link ? { class: `primary--text` } : false">
              <div class="text-h3">
                <v-icon class="mb-1">{{item.icone}}</v-icon>
                {{item.nome}}
              </div>
              <div class="text text-gray mt-2">
                {{item.lead}}
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row v-if="relatorios_comerciais.length > 0">
          <v-col cols="12">
            <div class="text-h1 mb-0">
              Relatórios comerciais
            </div>
          </v-col>
          <v-col cols="12" sm="6" md="6" lg="4" xl="4" v-for="(item, index) in relatorios_comerciais" :key="index">
            <div class="item_lista" :class="item.link ? 'cursor-pointer' : ''" @click="gotoUrl(item.link)" v-ripple="item.link ? { class: `primary--text` } : false">
              <div class="text-h3">
                <v-icon class="mb-1">{{item.icone}}</v-icon>
                {{item.nome}}
              </div>
              <div class="text text-gray mt-2">
                {{item.lead}}
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
// import Api from '@API'
export default {
  data () {
    return {
      loading: true,
      relatorios_gerenciais: [],
      relatorios_financeiros: [
        // {
        //   icone: 'savings',
        //   nome: 'Financiamento',
        //   link: '/relatorios/financiamento',
        //   lead: 'Apresenta informações sobre o financiamento de clientes'
        // }
      ],
      relatorios_comerciais: [
        {
          icone: 'emoji_objects',
          nome: 'Oportunidades geradas',
          link: '/relatorios/oportunidades-geradas',
          lead: 'Apresenta informações relevantes sobre as oportunidades de negócios geradas'
        },
        {
          icone: 'description',
          nome: 'Propostas geradas',
          link: '/relatorios/propostas-geradas',
          lead: 'Apresenta informações relevantes sobre as propostas geradas para clientes'
        },
        {
          icone: 'request_page',
          nome: 'Orçamentos gerados',
          link: '/relatorios/orcamentos-gerados',
          lead: 'Apresenta informações sobre os orçamentos gerados no sistema'
        }
      ]
    }
  },
  methods: {
    gotoUrl (link) {
      this.$router.push({ path: link }).catch(() => {})
    }
  },
  created () {
    this.loading = false
  }
}
</script>

<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.item_lista {
  border: 1px $primary solid;
  border-left-width: 10px;
  height: 100%;
  padding: 15px;
  .text-h3 {
    margin-bottom: 25px;
    position: relative;
    &:before {
      background: $primary;
      bottom: -10px;
      content: '';
      height: 1px;
      left: -15px;
      position: absolute;
      width: calc(100% + 30px);
    }
  }
  @media (max-width: 767px){}
}
</style>



// WEBPACK FOOTER //
// src/pages/relatorios/Relatorios.vue